export default __webpack_public_path__ + "static/media/alpha-green.54d5b20f.svg";